<template>
  <section class="delivery-costs" v-if="returnDeliveryOption !== 'no_delivery' || pickupDeliveryOption !== 'no_delivery'">
    <div class="inner">

      <div class="title" v-if="pickupDeliveryOption !== 'no_delivery'">
        <i class="fal fa-truck"></i>
        <div class="txt">
          <strong>Wir transportieren dieses Auto</strong>
          <span v-if="pickupDeliveryOption !== 'no_delivery' && returnDeliveryOption !== 'no_delivery' && this.returnDisplayLocation">Prüfe die Liefer- und Abholkosten</span>
          <span v-if="pickupDeliveryOption !== 'no_delivery' && returnDeliveryOption === 'no_delivery' || !this.returnDisplayLocation">Prüfe die Lieferkosten</span>
        </div>
      </div>

      <form class="form-container locationField" :id="id" :action="deliveryCostRoute" method="POST" v-on:submit.prevent="calculate" v-if="pickupDeliveryOption !== 'no_delivery'">

          <div class="location-field">
            <input class="form-control" ref="autocompleteMobile" onfocus="value = ''" placeholder="Lieferadresse" type="text" />
          </div>

          <div class="costs-footer">
            <input :value="csrf" name="_token" type="hidden" />
            <f-button v-if="!delivery.calculating" class="mb-3" variant="outline-secondary" type="submit" block>
              Lieferkosten berechnen
            </f-button>
            <f-button v-else class="mb-3" variant="outline-secondary" block disabled>
              <i class="fal fa-tire fa-spin"></i>
              berechne ...
            </f-button>
            <f-alert v-if="delivery.error" variant="warning" class="mt-3">
              <p>{{ delivery.errorMessage }}</p>
            </f-alert>

            <f-alert v-if="fuelIdentifier == 'ELECTRICITY' && pickupDeliveryOption == 'faaren_delivery'" variant="warning" class="mt-3">
              <i class="fal fa-info-circle"></i>
              evtl. Zusatzkosten durch Ladestops<br/>
              Weitere Infos hierzu in den <a href="/agbs/agb-de">AGB</a>.
            </f-alert>

          </div>
      </form>

      <div class="pickup-location" v-bind:class = "(pickupDeliveryOption == 'no_delivery') ? 'no-calculator' : ''" v-if="pickupDisplayLocation && !this.sameAddress">
        <i class="fal fa-map-marker-alt"></i>
        <div class="txt">
            <div class="left">
                <b>Abholort</b>
                <span>{{ pickupDisplayLocation }}</span>
            </div>
            <div class="right" v-if="(this.selectedCalculationOption === 'pick-up' || this.selectedCalculationOption === 'both') && delivery.show && !delivery.calculating && !delivery.error">
                <span>Kosten: {{ deliveryPickupCosts }}</span>
                <span>Entfernung: {{ delivery.distance }}</span>
            </div>
        </div>
      </div>

      <div class="return-location" v-if="this.returnDeliveryOption !== 'no_delivery' && this.returnDisplayLocation && !this.sameAddress">
        <i class="fal fa-undo"></i>
        <div class="txt">
            <div class="left">
                <b>Rückgabeort</b>
                <span>{{ returnDisplayLocation }}</span>
            </div>
            <div class="right" v-if="(this.selectedCalculationOption === 'return' || this.selectedCalculationOption === 'both') && delivery.show && !delivery.calculating && !delivery.error">
                <span>Kosten: {{ deliveryReturnCosts }}</span>
                <span>Entfernung: {{ this.returnDelivery.distance }}</span>
            </div>
        </div>
      </div>

      <div class="pickup-return-location" v-if="this.pickupDisplayLocation && this.returnDisplayLocation && this.sameAddress">
        <i class="fal fa-map-marker-alt"></i>
        <div class="txt">
            <div class="left">
                <b>Abhol- und Rückgabeort</b>
                <span>{{ pickupDisplayLocation }}</span>
            </div>
            <div class="right" v-if="this.selectedCalculationOption === 'both' && delivery.show && !delivery.calculating && !delivery.error">
                <span>Kosten jeweils: {{ deliveryPickupCosts }}</span>
                <span>Entfernung: {{ delivery.distance }}</span>
            </div>
        </div>
      </div>

        <div class="title">
            <div class="txt">
                <strong>Du hast die Wahl</strong>
                <span>Lieferung und Abholung sind optional.</span>
                <span>Die Lieferkosten sind exkl. Tanken und Laden.</span>
                <span>Preise sind inkl. MwSt.</span>
                <span>Entscheide später über deine Lieferoptionen.</span>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AdDeliveryCostCalculator",
  props: {
    deliveryCostRoute: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false,
      default: "delivery-cost-calculator"
    },
    currency: {
      type: String,
      required: false,
      default: "EUR"
    },
    locale: {
      type: String,
      required: false,
      default: "de-DE"
    },
    country: {
      type: String,
      required: false,
      default: "de"
    },
	  fuelIdentifier: {
      type: String,
      required: false,
      default: "DIESEL"
    },
	  pickupDeliveryOption: {
      type: String,
      required: false,
      default: "partner_delivery"
    },
    returnDeliveryOption: {
      type: String,
      required: false,
      default: "partner_delivery"
    },
    deliveryCostCalculatorVehicleData: {
      type: Object,
      required: false
    }
  },
  data: () => {
    return {
      csrf: document
          .querySelector ('meta[name="csrf-token"]')
          .getAttribute ("content"),
      autocomplete: '',
      delivery: {
        addressString: "",
        costs: false,
        costs_unformatted: false,
        duration: false,
        distance: false,
        calculating: false,
        show: false,
        error: false,
        errorMessage: ""
      },
      returnDelivery: {
        costs: false,
        costs_unformatted: false,
        duration: false,
        distance: false
      },
      selectedCalculationOption: 'both',
    }
  },
  computed: {
    deliveryPickupCosts () {
      return this.getCosts(this.delivery)
    },
    deliveryReturnCosts () {
      return this.getCosts(this.returnDelivery)
    },
    pickupDisplayLocation() {
        return this.getDisplayLocation(this.deliveryCostCalculatorVehicleData.addressPlz, this.deliveryCostCalculatorVehicleData.addressCity)
    },
    returnDisplayLocation() {
        return this.getDisplayLocation(this.deliveryCostCalculatorVehicleData.firstPickupLocationPlz, this.deliveryCostCalculatorVehicleData.firstPickupLocationCity)
    },
    sameAddress() {
        if (this.pickupDisplayLocation === this.returnDisplayLocation) {
            return true
        } else {
            return false
        }
    },
    getLocationFromApi() {
        if (this.pickupDisplayLocation && this.returnDisplayLocation) {
          return 'both'
        } else {
          if (this.pickupDisplayLocation) {
            return 'pick-up'
          } else {
            return 'return'
          }
        }
    }
  },
  methods: {
    calculate: function () {
      var place = this.autocompleteMobile.getPlace();
      place = place.formatted_address;
      this.delivery.addressString = place;

      var self = this;
      this.delivery.calculating = true;
      this.delivery.show = false;
      this.delivery.costs = false;
      this.delivery.distance = false;
      this.returnDelivery.costs = false;
      this.returnDelivery.distance = false;
      this.delivery.error = false;
      this.delivery.errorMessage = '';
      axios
          .post (this.deliveryCostRoute, {
              address_string: this.delivery.addressString,
              duration_string: this.duration,
              delivery_methods: this.getLocationFromApi
          })
          .then (function (res) {
              let response = res.data;

              if (response.hasOwnProperty('error')) {
                self.delivery.error = true;
                self.delivery.errorMessage = 'Die Kosten können gerade nicht ermittelt werden.'
                self.delivery.costs = response.result
                self.delivery.duration = response.duration
                self.delivery.calculating = false;
                self.delivery.show = true;
                return;
              }

              for (let key in response) {
                  if (key === 'pick-up') {
                      self.delivery.costs = response[key].result;
                      self.delivery.costs_unformatted = response[key].costs_unformatted;
                      self.delivery.duration = response[key].duration;
                      self.delivery.distance = response[key].distance;
                  }
                  if (key === 'return') {
                      self.returnDelivery.costs = response[key].result;
                      self.returnDelivery.costs_unformatted = response[key].costs_unformatted;
                      self.returnDelivery.duration = response[key].duration;
                      self.returnDelivery.distance = response[key].distance;
                  }
              }
              self.delivery.calculating = false;
              self.delivery.show = true;
          })
          .catch (function (err) {
            console.log(err)
              self.delivery = {
                  duration: err.data.duration,
                  costs: err.data.result,
                  costs_unformatted: err.data.costs_unformatted,
                  error: err.data.error,
                  errorMessage: err.data.errorMessage,
                  calculating: false,
                  show: false,
              }
          });
    },
    getCosts(location) {
      if (location.costs_unformatted) {
        const value = new Intl.NumberFormat (this.locale, {
          style: 'currency',
          currency: this.currency
        }).format (location.costs_unformatted)
        return value
      }
      return ""
    },
    getDisplayLocation(postal_code, city) {
            return (`${postal_code} ${city}`).trim()
    },
    initAutocomplete: function () {
      this.autocompleteMobile = new google.maps.places.Autocomplete (
          this.$refs.autocompleteMobile,
          {
            types: ["geocode"],
            componentRestrictions: {country: this.country}
          }
      );
      this.autocompleteMobile.addListener ("place_changed", () => {
        var place = this.autocompleteMobile.getPlace ();
        place = place.formatted_address;
        this.delivery.addressString = place;
      });
    },
    fillInAddress: function () {
      this.input = this.autocomplete.getPlace ().formatted_address;
    }
  },
  mounted: function () {
    this.initAutocomplete ();
  }
};
</script>

<style scoped></style>
